import React from 'react';
import PropTypes from 'prop-types';

class ResumenCorreo extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      correo_nombre_campo: '',
      correo_direccion_campo: '',
      correo_mensaje_campo: '',
    };
  }

  componentWillMount() {
    const { steps } = this.props;
    const { correo_nombre_campo, correo_direccion_campo, correo_mensaje_campo } = steps;

    this.setState({ correo_nombre_campo, correo_direccion_campo, correo_mensaje_campo  });
  }

  render() {
    const { correo_nombre_campo, correo_direccion_campo, correo_mensaje_campo } = this.state;
    const date = new Date();
    const [month, day, year] = [
    date.getMonth()+1,
    date.getDate(),
    date.getFullYear(),
    ];
    return (
    <div role="alert" aria-live="assertive" aria-atomic="true" className="toast show" data-bs-autohide="false">
        <div className="toast-header">
          <strong className="me-auto">Tu correo</strong>
          <small>{day+'/'+month+'/'+year}</small>
        </div>
        <div className="toast-body">
          &lt;{correo_direccion_campo.value}&gt;<br/>
          <b>{correo_nombre_campo.value}</b> <br/>
          <br/>
          {correo_mensaje_campo.value}
        </div>
    </div>
    );
  }
}

ResumenCorreo.propTypes = {
  steps: PropTypes.object,
};

ResumenCorreo.defaultProps = {
  steps: undefined,
};

export default ResumenCorreo